<template>
  <el-dialog
      title="请选择号型"
      :visible.sync="SizeDialogVisible"
      :before-close="cancelModelBox"
      :close-on-click-modal="false"
      custom-class="size_dialog_box"
  >
    <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card" class="tab_box">
      <el-tab-pane  v-for="item in tabList" :label="item.label" :modelCode="item.modelCode" :name="item.name" :key="item.name" class="size_tab_pane">
        <span slot="label">
          {{ item.label }}
        </span>
        <component :is="cmpName" :DataList="DataList" :LocalKey="LocalKey" v-if="SizeDialogVisible" :ref="item.name"></component>
      </el-tab-pane>
    </el-tabs>
      <span slot="footer" class="dialog-footer">
      <el-button @click="cancelModelBox">取 消</el-button>
      <el-button type="primary" @click="PreserveSize">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import BabySize from "./BabySize";
import ChildSize from "./ChildSize";
import BoysAndGirls from './BoysAndGirls'
import WomenWear from './WomenWear'
import MensWear from './MensWear'
import OtherProducts from './OtherProducts'
import {ToolTypeQryByModel} from "src/request/apis";
export default {
  name: "SizeModelBox",
  props:{
    LocalKey:{
      type:String,
      default:()=>''
    },
    SizeDialogVisible:{
      type: Boolean,
      default: false
    },
    apiHost: {
      type: String,
      default: ''
    }
  },
  components:{
    BabySize,
    ChildSize,
    BoysAndGirls,
    WomenWear,
    MensWear,
    OtherProducts
  },
  data() {
    return {
      activeName: 'BabySize',
      tabList:[
        {
          name:'BabySize',
          label:'婴幼儿',
          modelCode:100
        },
        {
          name:'ChildSize',
          label:'小童',
          modelCode:101
        },
        {
          name:'BoysAndGirls',
          label:'男女大童',
          modelCode:102
        },
        {
          name:'WomenWear',
          label:'女士服装',
          modelCode:103
        },
        {
          name:'MensWear',
          label:'男士服装',
          modelCode:104
        },
        {
          name:'OtherProducts',
          label:'其他产品',
          modelCode:105
        }
      ],
      cmpName: 'BabySize',
      DataList: {},
    }
  },
  created() {
    this.GetList(100)
  },
  methods:{
    GetList(id){
      ToolTypeQryByModel({
        modelCode: id
      }, this.apiHost)
        .then((res) => {
          let data=res.data
          let DownMaxLength=0
          let UpMaxLength=0
          for(let i in data){

            let sum=data[i]['DOWN'].length-data[i]['UP'].length
            if(sum>0){
              let data1=new Array(sum).fill({})
              data[i]['UP']=[...data[i]['UP'],...data1]
            }else if(sum<0){
              let data1=new Array(-sum).fill({})
              data[i]['DOWN']=[...data[i]['DOWN'],...data1]
            } else {
              if (data[i]['DOWN'].length === 1) {
                let data1=new Array(2).fill({})
                data[i]['UP']=[...data[i]['UP'],...data1]
                data[i]['DOWN']=[...data[i]['DOWN'],...data1]
              } else if (data[i]['DOWN'].length === 2) {
                let data1=new Array(1).fill({})
                data[i]['UP']=[...data[i]['UP'],...data1]
                data[i]['DOWN']=[...data[i]['DOWN'],...data1]
              }
            }
          }
          console.log(data)
          this.DataList=data
        })
        .catch((e) => {
        this.loading = false
        })
    },
    cancelModelBox(){
      this.$emit('ChangeSizeFocus', false,false);
    },
    PreserveSize(){
      this.$parent.SizeTotal()
      this.$emit('ChangeSizeFocus', false,true);
    },
    handleClick(tab, event) {
      this.cmpName = tab.name
      this.activeName = tab.name
      this.GetList(tab.$attrs.modelCode)
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog {
  width: auto;
  min-width: 50% !important;
  max-width: 78% !important;
}
.tab_box{
  border: 1px solid #D2D2D2;
  .size_tab_pane{
    padding: 15px 31px;
  }
}
::v-deep .el-tabs__nav{
  width: 100%;
}
::v-deep .el-tabs__item{
  width: 16.75%;
  text-align: center;
  border-right: 1px solid #D2D2D2 !important;
}
::v-deep .el-tabs__nav .el-tabs__item:last-child{
  border-right: none !important;
}
</style>